



































import Vue, { PropType } from 'vue'
import UiRichText from '../../UiRichText/UiRichText.vue'
import { Links } from './UiStoreLocatorCountries.types'

export default Vue.extend({
  name: 'UiStoreLocatorCountries',
  components: {
    UiRichText
  },
  props: {
    header: {
      type: String,
      default: 'Select Location'
    },
    description: {
      type: String,
      default: ''
    },
    links: {
      type: Array as PropType<Links>,
      default: () => []
    }
  },
  computed: {
    langLinks (): Links {
      return this.links?.filter(lang => lang.link !== '')
    }
  }
})
